import { useMemo } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { VehicleEngineType } from '~/shared';
import { StyledButtonContent, StyledIcon } from './ButtonBuy.styled';

const ButtonBuy = ({
	children,
	disabled,
	engineType,
	onClick,
}: React.HTMLAttributes<HTMLButtonElement> & {
	disabled?: boolean;
	engineType: VehicleEngineType;
}) => {
	const disabledText = useMemo(
		() =>
			engineType === VehicleEngineType.Petrol
				? 'Укажите количество'
				: 'Укажите кол-во',
		[engineType],
	);

	return (
		<Button
			color={ButtonColors.Buy}
			height={ButtonHeight.Height40}
			disabled={disabled}
			style={{
				width: engineType === VehicleEngineType.Petrol ? '200px' : '160px',
			}}
			onClick={onClick}
		>
			<StyledButtonContent>
				{!disabled && <StyledIcon />}
				<Text>{disabled ? disabledText : children}</Text>
			</StyledButtonContent>
		</Button>
	);
};

export { ButtonBuy };
